import React from 'react';
import {
  Switch,
  Route,
  useRouteMatch,
} from 'react-router-dom';

import {
  PageAnnouncements,
  PageAnnouncement,
} from '../pages/announcements';

const RouteAnnouncements = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <PageAnnouncements />
      </Route>
      <Route path={`${path}/:_id`}>
        <PageAnnouncement />
      </Route>
    </Switch>
  );
};

export default RouteAnnouncements;
